import React from 'react';
import { createProjectOptions } from '../../common/constants';

const CreateProjectOld = ({
  handleContinue,
  updatePreferences,
  projectCreationMethod,
  visualInitializationMode,
}) => {
  return (
    <form className="create-project-selection" onSubmit={handleContinue}>
      <fieldset className="create-project-selection__fieldset">
        <legend>How would you like to build?</legend>
        <p className="create-project-selection__intro">
          Choose how you'd like to start your new project.
        </p>
        <div className="create-project-selection__options">
          <div className="create-project-selection__column">
            <label className="create-project-selection__option" htmlFor={`create-project-visual`}>
              <input
                id={`create-project-visual`}
                type="radio"
                name="projectCreationMethod"
                value="visual"
                checked={projectCreationMethod === 'visual'}
                onChange={() => updatePreferences({ projectCreationMethod: 'visual' })}
                aria-describedby={`create-project-visual-description`}
              />
              <span className="create-project-selection__card">
                <span className="create-project-selection__card-top">
                  <i className="material-icons" aria-hidden="true">
                    dashboard
                  </i>
                  <span className="create-project-selection__badge">No-code</span>
                </span>
                <span className="create-project-selection__title">
                  Visual Drag-and-Drop Builder
                </span>
                <span
                  className="create-project-selection__description"
                  id="create-project-visual-description"
                >
                  Design your app visually with drag-and-drop components.
                </span>
              </span>
            </label>
            <div className="create-project-selection__initialization">
              {projectCreationMethod === 'visual' && (
                <label className="create-project-selection__clone" htmlFor="create-project-clone">
                  <input
                    id="create-project-clone"
                    type="checkbox"
                    name="visualInitializationMode"
                    checked={visualInitializationMode === 'clone'}
                    onChange={(event) =>
                      updatePreferences({
                        visualInitializationMode: event.target.checked ? 'clone' : 'blank',
                      })
                    }
                    aria-describedby="create-project-clone-description"
                  />
                  <span>
                    <span className="create-project-selection__clone-title">
                      Start from a template or existing project (Optional)
                    </span>
                    <span
                      className="create-project-selection__description"
                      id="create-project-clone-description"
                    >
                      Reuse an existing design or project instead of starting from scratch.
                    </span>
                  </span>
                </label>
              )}
            </div>
          </div>
        </div>
      </fieldset>
      <div className="create-project-selection__actions">
        <button type="submit" className="btn btn-success text-white m-0">
          Continue{' '}
          <i className="material-icons" aria-hidden="true">
            arrow_forward
          </i>
        </button>
      </div>
    </form>
  );
};

export default CreateProjectOld;
